const { encode } = require("@msgpack/msgpack");

const ArgumentType = require('../../extension-support/argument-type');
const BlockType = require('../../extension-support/block-type');
const Cast = require('../../util/cast');
const log = require('../../util/log');
const MathUtil = require('../../util/math-util');
const formatMessage = require('format-message');
const Locales = ['ja', 'ja-Hira', 'en'];
require('regenerator-runtime/runtime');
const AsyncLock = require('async-lock');
const lock = new AsyncLock();

const Message = {
    qrCode : {
        'ja': 'QRコード',
        'ja-Hira': 'QRコード',
        'en': 'QR Code'
    },
    motorDrive: {
        'en':'motor[PIN] Speed [SPEED]',
        'ja':'モーター[PIN]を速さ[SPEED]にする',
        'ja-Hira':'モーター[PIN]をはやさ[SPEED]にする',
    },
    connectMotor: {
        'en':'connect motor',
        'ja':'モーターモジュールを接続',
        'ja-Hira':'モーターモジュールをせつぞく',
    },
    connectController: {
        'en':'connect controller',
        'ja':'コントローラーを接続',
        'ja-Hira':'コントローラーをせつぞく',
    },
    valueJoystickX: {
        'en':'joystick X value',
        'ja':'スティックXの値',
        'ja-Hira':'スティックXのあたい',
    },
    valueJoystickY: {
        'en':'joystick Y value',
        'ja':'スティックYの値',
        'ja-Hira':'スティックYのあたい',
    },
    valueButtonA: {
        'en':'button [BTN] value',
        'ja':'ボタン[BTN]の値',
        'ja-Hira':'ボタン[BTN]のあたい',
    },
    valueButtonB: {
        'en':'button B value',
        'ja':'ボタンBの値',
        'ja-Hira':'ボタンBのあたい',
    },
    valueButtonJ: {
        'en':'joystick push value',
        'ja':'スティック押しこみの値',
        'ja-Hira':'スティックおしこみのあたい',
    },
    servoDrive: {
        'en':'servo[PIN] Angle [ANGLE]',
        'ja':'サーボ[PIN]を角度[ANGLE]にする',
        'ja-Hira':'サーボ[PIN]をかくど[ANGLE]にする',
    },
    whenButtonPressed: {
        'en':'when [BTN] button pressed',
        'ja':'ボタン [BTN] が押された時',
        'ja-Hira':'ボタン [BTN] がおされたとき',
    },
    whenButtonReleased: {
        'en':'when [BTN] button released',
        'ja':'ボタン [BTN] が放された時',
        'ja-Hira':'ボタン [BTN] がはなされたとき',
    },
    whenJoystickValueChanged: {
        'en':'when joystick [AXIS] changed',
        'ja':'ジョイスティックの [AXIS] が変化した時',
        'ja-Hira':'ジョイスティックの [AXIS] がかわったとき',
    }, 
    
}

const StudeoButtons = {
    A: 'A',
    B: 'B',
    J: 'J',
};

const StudeoJoystick = {
    X: 'X',
    Y: 'Y',
    ANY: 'ANY',
};

const STUDEO_SERVO_PINS = {
    1: '1',
    2: '2',
    3: '3',
    4: '4',
};

const STUDEO_MOTOR_PINS = {
    1: '1',
    2: '2',
};

const blockIconURI = 'data:image/png;base64,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';

class Scratch3NewBlocks {

    constructor(runtime, vm) {
        this.runtime = runtime;
        this.vm = vm;
        this.locale = this._getViewerLanguageCode();
        window.viviwareclass = this;
        this.buttonA = false;
        this.buttonB = false;
        this.buttonJ = false;
        // 「BLEから届いた最新値」をとりあえず格納するための変数
        this._joystickXNew = 0;
        this._joystickYNew = 0;
        this._joystickXChanged = false;
        this._joystickYChanged = false;
    
        // 実際にScratchから参照される値
        this.joystickX = 0;
        this.joystickY = 0;
        this.joystickX_before = 0;
        this.joystickY_before = 0;

        this.joystickChangedFlag = false;  // 変化を検知するためのフラグ
        this.updateFlag = false;  // 更新検知フラグ
        this.joystickLastUpdateTime = Date.now(); // 最後に値が更新された時間を記録
        this.joystickUpdateInterval = 100; // ミリ秒単位での強制チェック間隔
        this.beforeWhenJoystickValueChanged = false;
        this.beforeWhenSliderValueChanged = false;

        this.buttonA_pressed_before = false;
        this.buttonB_pressed_before = false;
        this.buttonJ_pressed_before = false;

        this.buttonA_released_before = true;
        this.buttonB_released_before = true;
        this.buttonJ_released_before = true;

        this.device = null;
        this.server = null;
        this.serviceUuid = "6c6d1392-9637-3b48-53a8-962853bff36b";
        this.characteristicUuid = "c3af7ad9-13e5-2d18-48c8-52bc11e99c03";
        this.characteristicLogicUuid = "a4a2401b-ab27-e130-b0f5-bcac22c3880c";

        this.handleCharacteristicValueChanged = this.handleCharacteristicValueChanged.bind(this);
        this.whenPt2ButtonPressed = this.whenPt2ButtonPressed.bind(this);
        this.whenPt2ButtonReleased = this.whenPt2ButtonReleased.bind(this);

        this.motor1value = 0;
        this.motor2value = 0;
        this.servo1value = -1;
        this.servo2value = -1;
        this.servo3value = -1;
        this.servo4value = -1;
        this.sendValue =  [0, 0, -1, -1, -1, -1]; 
        this.needToSend = false;

        // 定期実行
        setInterval(() => this.sendDataBle(), 60); // 秒間15回の頻度でsendDataを実行
        setInterval(() => this._updateValues(), 30);
    }

    get BUTTONS_MENU() {
        return [
            {
                text: 'A',
                value: StudeoButtons.A
            },
            {
                text: 'B',
                value: StudeoButtons.B
            },
            {
                text: 'J',
                value: StudeoButtons.J
            },
        ];
    }

    get JOYSTICK_MENU() {
        return [
            {
                text: 'X',
                value: StudeoJoystick.X
            },
            {
                text: 'Y',
                value: StudeoJoystick.Y
            },
            {
                text: 'ANY',
                value: StudeoJoystick.ANY
            }
        ];
    }

    get SERVO_PINS() {
        return [
            {
                text: '1',
                value: STUDEO_SERVO_PINS[1]
            },
            {
                text: '2',
                value: STUDEO_SERVO_PINS[2]
            },
            {
                text: '3',
                value: STUDEO_SERVO_PINS[3]
            },
            {
                text: '4',
                value: STUDEO_SERVO_PINS[4]
            },
        ];
    }
    
    get MOTOR_PINS() {
        return [
            {
                text: '1',
                value: STUDEO_MOTOR_PINS[1]
            },
            {
                text: '2',
                value: STUDEO_MOTOR_PINS[2]
            },
        ];
    }

    getInfo() {

        this.locale = this._getViewerLanguageCode();
        return {
            id: 'remono',
            name: 'remono',
            blockIconURI: blockIconURI,
            blocks: [
                {
                    opcode: 'connect_mtr',
                    blockType: BlockType.COMMAND,
                    text: Message.connectMotor[this.locale],
                    arguments: {
                        ANGLE: {
                            type: ArgumentType.NUMBER,
                            defaultValue: 0
                        }
                    }
                },
                {
                    opcode: 'connect_con',
                    blockType: BlockType.COMMAND,
                    text: Message.connectController[this.locale],
                    arguments: {
                        ANGLE: {
                            type: ArgumentType.NUMBER,
                            defaultValue: 0
                        }
                    }
                },
                {
                    opcode: 'motorDrive',
                    blockType: BlockType.COMMAND,
                    text: Message.motorDrive[this.locale],
                    arguments: {
                        PIN: {
                            type: ArgumentType.STRING,
                            menu: 'motor_pins',
                            defaultValue: STUDEO_MOTOR_PINS[1]
                        },
                        SPEED: {
                            type: ArgumentType.NUMBER,
                            defaultValue: 0
                        }
                    }
                },
                {
                    opcode: 'servoDrive',
                    blockType: BlockType.COMMAND,
                    text: Message.servoDrive[this.locale],
                    arguments: {
                        PIN: {
                            type: ArgumentType.STRING,
                            menu: 'servo_pins',
                            defaultValue: STUDEO_SERVO_PINS[1]
                        },
                        ANGLE: {
                            type: ArgumentType.NUMBER,
                            defaultValue: 0
                        }
                    }
                },
                {
                    opcode: 'whenPt2ButtonPressed',
                    blockType: BlockType.HAT,
                    text: Message.whenButtonPressed[this.locale],
                    arguments: {
                        BTN: {
                            type: ArgumentType.STRING,
                            menu: 'buttons',
                            defaultValue: StudeoButtons.A
                        }
                    }
                },
                {
                    opcode: 'whenPt2ButtonReleased',
                    blockType: BlockType.HAT,
                    text: Message.whenButtonReleased[this.locale],
                    arguments: {
                        BTN: {
                            type: ArgumentType.STRING,
                            menu: 'buttons',
                            defaultValue: StudeoButtons.A
                        }
                    }
                },
                {
                    opcode: 'whenJoystickValueChanged',
                    blockType: BlockType.HAT,
                    text: Message.whenJoystickValueChanged[this.locale],
                    arguments: {
                        AXIS: {
                            type: ArgumentType.STRING,
                            menu: 'joystick',
                            defaultValue: this.JOYSTICK_MENU.ANY
                        }
                    }
                },
                {
                    opcode: 'getRemonoButton',
                    blockType: BlockType.BOOLEAN,
                    text: Message.valueButtonA[this.locale],
                    arguments: {
                        BTN: {
                            type: ArgumentType.STRING,
                            menu: 'buttons',
                            defaultValue: StudeoButtons.A
                        }
                    }
                },
                {
                    opcode: 'getJoystickX',
                    blockType: BlockType.REPORTER,
                    text: Message.valueJoystickX[this.locale],
                },
                {
                    opcode: 'getJoystickY',
                    blockType: BlockType.REPORTER,
                    text: Message.valueJoystickY[this.locale],
                },
                {
                    opcode: 'writeProgram',
                    blockType: BlockType.COMMAND,
                    text: 'Write Logic to remono',
                },

            ],
            menus: {
                motor_pins: {
                    acceptReporters: true,
                    items: this.MOTOR_PINS
                },
                servo_pins: {
                    acceptReporters: true,
                    items: this.SERVO_PINS
                },
                buttons: {
                    acceptReporters: true,
                    items: this.BUTTONS_MENU
                },
                joystick: {
                    acceptReporters: true,
                    items: this.JOYSTICK_MENU
                },
            }
        };
    }

    _getViewerLanguageCode () {
        const locale = formatMessage.setup().locale;
        if (Locales.includes(locale)) {
            return locale;
        }
        return 'en';
    }

    writeLog(args) {
        const text = Cast.toString(args.TEXT);
        log.log(text);
        console.log(module);
    }
    setButton() {
        console.log("setButton");
        mytext = "hello";
    }

    connect_mtr(args) {
        console.log("connect_mtr");

        let options = {
            filters: [
                { namePrefix: "studeo_mtr_" },
            ],
            optionalServices: ["6c6d1392-9637-3b48-53a8-962853bff36b"]
          };
        // 既存のデバイスがあれば、イベントリスナーを削除
        if (this.device) {
            this.device.removeEventListener('gattserverdisconnected', this.handleDisconnect_M);
        }
        navigator.bluetooth 
        .requestDevice(options)
        .then((device) => {
            console.log(`connected: ${device.name}`);
            this.device = device;
            // 既存のイベントリスナーを削除
            device.removeEventListener('gattserverdisconnected', this.handleDisconnect_M);
            // イベントリスナーを設定
            this.handleDisconnect_M = event => {
                console.log('モーターモジュールが切断されました！');
                alert('モーターモジュールが切断されました！');
            };
            device.addEventListener('gattserverdisconnected', this.handleDisconnect_M);
            return device.gatt.connect();
        })
        .then(server => {
            // 接続成功
            console.log('GATTサーバーに接続しました');
            this.server = server;
            // キャラクタリスティックをキャッシュ
            return server.getPrimaryService(this.serviceUuid).then(service => {
                return Promise.all([
                    service.getCharacteristic(this.characteristicUuid).then(characteristic => {
                        this.motorCharacteristic = characteristic;
                    }),
                    // LogicのUUID
                    service.getCharacteristic(this.characteristicLogicUuid).then(characteristic => {
                        this.logicCharacteristic = characteristic;
                    }),
                ]);
            });
            
        })
        .catch((error) => console.error(`何かがうまくいきませんでした ${error}`));
        
    }

    connect_con(args) {
        console.log("connect_con");

        let options = {
            filters: [
                { namePrefix: "studeo_con_"}
            ],
            optionalServices: ["6c6d1392-9637-3b48-53a8-962853bff36b"]
            };
        navigator.bluetooth 
        .requestDevice(options)
        .then((device) => {
            console.log(`connected: ${device.name}`);
            device.gatt.connect()
            .then(server => server.getPrimaryService(this.serviceUuid))
            .then(service => service.getCharacteristic('265d940f-c36a-e742-2f80-f9a9893f2aea'))
            .then(characteristic => characteristic.startNotifications())
            .then(characteristic => {
              characteristic.addEventListener('characteristicvaluechanged', this.handleCharacteristicValueChanged);
              console.log('Notifications have been started.');
            })
            .catch(error => console.error(error));
            // 既存のイベントリスナーを削除
            device.removeEventListener('gattserverdisconnected', this.handleDisconnect_C);
            // イベントリスナーを設定
            this.handleDisconnect_C = event => {
                console.log('コントローラーが切断されました！');
                alert('コントローラーが切断されました！');
            };
            device.addEventListener('gattserverdisconnected', this.handleDisconnect_C);
        })
        .then(server => {
            // 接続成功
            console.log('GATTサーバーに接続しました');
            this.server = server;
        })
        .catch((error) => console.error(`何かがうまくいきませんでした ${error}`));
    }
    
    // キャラクタリスティックの値が変更されたときに呼び出される関数
    handleCharacteristicValueChanged(event) {
        const rawData = event.target.value;
        
        // 受信したバイト配列から文字列を生成
        const values = Scratch3NewBlocks.parseCommaSeparatedNumbers(rawData);
        
        // 文字列配列から整数値を取り出し
        this._joystickXNew = parseInt(values[1], 10);
        this._joystickYNew = parseInt(values[2], 10);
        const pushed = parseInt(values[3], 10);
        const buttonA = parseInt(values[4], 10);
        const buttonB = parseInt(values[5], 10);
        
        // ここで取り出した値を使用して何らかの処理を行う
        // 例: ボタンAとBの状態をログに出力
        this.setButtonA(buttonA);
        this.setButtonB(buttonB);
        this.setButtonJ(pushed);
    }
  
    // setIntervalで呼ばれるフレーム処理
    _updateValues() {
        console.log('update JoystickX_before:', this.joystickX_before,' JoystickX:', this.joystickX, ' JoystickXNew:', this._joystickXNew);
        // 1フレーム内だけ「前回値」と比較する
        this.joystickX_before = this.joystickX;
        this.joystickY_before = this.joystickY;

        // 変更があればフラグを立てる
        this._joystickXChanged = (this._joystickXNew !== this.joystickX);
        this._joystickYChanged = (this._joystickYNew !== this.joystickY);

        // 実際に今フレームの値を更新
        this.joystickX = this._joystickXNew;
        this.joystickY = this._joystickYNew;
    }
    
    motorDrive(args) {
        lock.acquire('key', (done) => {
            const pin = args.PIN;
            let speed = args.SPEED; // 正規化の値をそのまま送る 
            speed = Math.max(-100, Math.min(100, speed));
            console.log(`motor drive ${pin}, speed ${speed}`);
            switch (pin) {
                case "1": 
                    this.motor1value = speed; 
                    this.sendValue[0] = speed;
                    break;
                case "2": 
                    this.motor2value = speed;
                    this.sendValue[1] = speed;
                    break;
            }
            console.log("send flag true");
            this.needToSend = true; // 送信フラグを立てる
            done();
        });    
    }

    sendDataBle() {
        lock.acquire('key', async (done) => {
            if (!this.needToSend) {
                done();
                return; // 送信する必要がなければ何もしない
            }
            if (!this.motorCharacteristic) {
                done();
                console.error('デバイスに接続されていません。');
                return;
            }
            try {
                const characteristic = this.motorCharacteristic;
                var bytes;
                if (this.device.name.includes("remono")) {
                    console.log("これはREMONOです");
                    let encoder = new TextEncoder();
                    bytes = encoder.encode(this.sendValue.join(","));
                } else {
                    console.log("sendValue: ", this.sendValue);
                    bytes = createMessagePackPacket(this.sendValue);
                }
                await characteristic.writeValue(bytes);
                this.needToSend = false;
                console.log("送信しました send flag false");
            } catch(error) {
                console.error(`データ送信に失敗しました2: ${error}`);
                this.needToSend = true;
            } 
            done();
        });
    }

    servoDrive(args) {
        const pin = args.PIN;
        const angle = args.ANGLE; // 正規化の値をそのまま送る 
        switch (pin) {
            case "1":
                 this.servo1value = angle;
                 this.sendValue[2] = angle;
                 break;
            case "2": 
                this.servo2value = angle;
                this.sendValue[3] = angle;
                break;
            case "3": 
                this.servo3value = angle;
                this.sendValue[4] = angle;
                break;
            case "4": 
                this.servo4value = angle;
                this.sendValue[5] = angle;
                break;
        }
        this.needToSend = true; // 送信フラグを立てる
    }

    static bytesToString(bytes) {
        return new TextDecoder('utf-8').decode(new Uint8Array(bytes));
      }

    static parseCommaSeparatedNumbers(dataView) {
        // DataViewから文字列を取得
        const str = new TextDecoder('utf-8').decode(new Uint8Array(dataView.buffer));
        
        // カンマで分割して数値の配列に変換
        const numbers = str.split(',').map(numStr => parseInt(numStr, 10));
      
        return numbers;
    }
      
    whenPt2ButtonPressed(args) {
        if (args.BTN === 'A') {
            if (!this.buttonA_pressed_before && this.buttonA) {
                return true;
            } 
            this.buttonA_pressed_before = this.buttonA;
        } else if (args.BTN === 'B') {
            if (!this.buttonB_pressed_before && this.buttonB) {
                return true;
            } 
            this.buttonB_pressed_before = this.buttonB;
        } else if (args.BTN === 'J') {
            if (!this.buttonJ_pressed_before && this.buttonJ) {
                return true;
            } 
            this.buttonJ_pressed_before = this.buttonJ;
        }
        return false;
    }

    whenPt2ButtonReleased(args) {
        if (args.BTN === 'A') {
            if (!this.buttonA_released_before && !this.buttonA) {
                return true;
            } 
            this.buttonA_released_before = !this.buttonA;
        } else if (args.BTN === 'B') {
            if (!this.buttonB_released_before && !this.buttonB) {
                return true;
            } 
            this.buttonB_released_before = !this.buttonB;
        } else if (args.BTN === 'J') {
            if (!this.buttonJ_released_before && !this.buttonJ) {
                return true;
            } 
            this.buttonJ_released_before = !this.buttonJ;
        }
        return false;
    }

    whenJoystickValueChanged(args) {
        // Xの変化有無チェック
        const changedX = (this.joystickX !== this.joystickX_before);
        // Yの変化有無チェック
        const changedY = (this.joystickY !== this.joystickY_before);
    
        // 「ANY」「X」「Y」それぞれに応じて真偽値を返す
        switch(args.AXIS) {
            case 'ANY':
                return changedX || changedY;
            case 'X':
                return changedX;
            case 'Y':
                return changedY;
        }
        // 万一ここにきたらfalse
        return false;
    }

    getJoystickX () {
        return this.joystickX;
    }

    getJoystickY () {
        return this.joystickY;
    }

    getButtonA () {
        return this.buttonA;
    }

    getRemonoButton (args) {
        if (args.BTN === 'A') {
            return this.buttonA;
        } else if (args.BTN === 'B') {
            return this.buttonB;
        } else if (args.BTN === 'J') {
            return this.buttonJ;
        } else {
            return false;
        }
    }

    setButtonA(valueA) {
        if (valueA) {
            this.buttonA = true;
        } else {
            this.buttonA = false;
        }
    }
    setButtonB(valueB) {
        if (valueB) {
            this.buttonB = true;
        } else {
            this.buttonB = false;
        }
    }
    setButtonJ(valueJ) {
        if (valueJ) {
            this.buttonJ = true;
        } else {
            this.buttonJ = false;
        }
    }
    setButtonX() {
        buttonX = true;
    }
    setButtonY() {
        buttonY = true;
    }

    writeProgram() {
        // vm.toJSON() が文字列を返す場合への対応
        const dataFromVm = this.vm.toJSON();
            
        let projectJsonObj;
        if (typeof dataFromVm === 'string') {
            // 返ってきたものが文字列ならパース
            try {
                projectJsonObj = JSON.parse(dataFromVm);
            } catch (err) {
                console.error('JSON.parse() に失敗:', err);
                return;
            }
        } else {
            // 返ってきたものが既にオブジェクトならそのまま使う
            projectJsonObj = dataFromVm;
        }
        
        console.log('projectJsonObj =', projectJsonObj);

        // もし targets が存在しない場合はここで弾く
        if (!projectJsonObj || !projectJsonObj.targets || !Array.isArray(projectJsonObj.targets)) {
            console.warn('projectJsonObj.targets が見つかりませんでした');
            return;
        }

        // ステージ (isStage:true) を探す
        const stageTarget = projectJsonObj.targets.find(target => target.isStage === true);
        if (!stageTarget) {
            console.log('ステージが見つかりませんでした');
            return;
        }

        // ステージの blocks を取り出す
        const stageBlocks = stageTarget.blocks;
        const stageBlocksJsonStr = JSON.stringify(stageBlocks);
        console.log('Stageのblocks要素のみ:', stageBlocksJsonStr);

        const messageToSend = "\x02" + stageBlocksJsonStr + "\x03";
        const encoder = new TextEncoder();
        const fullData = encoder.encode(messageToSend);
    
        // 512バイト上限を考慮して、さらに余裕を見て 200バイトずつなど分割する
        const maxChunkSize = 200;
        
        // 非同期で順番に書き込む例
        this.sendChunksSequentially(this.logicCharacteristic, fullData, maxChunkSize)
            .then(() => {
                console.log('すべてのチャンクを送信しました');
            })
            .catch(err => {
                console.error('チャンク送信中にエラー:', err);
            });
   }
   /**
     * 指定したCharacteristicに、バイト配列dataを chunkSize ずつ順番に書き込む
     */
    async sendChunksSequentially(characteristic, data, chunkSize) {
        // chunkSize バイトごとにループ
        for (let offset = 0; offset < data.length; offset += chunkSize) {
            const end = Math.min(offset + chunkSize, data.length);
            const chunk = data.slice(offset, end);
            // 1回の書き込み
            await characteristic.writeValue(chunk);
            console.log(`chunk [${offset}..${end}] を送信`);
        }
    }

}

function collectMetadata(vm, projectName = '', locale = '') {
    // TODO move most or all of this into a collectMetadata() method on the VM/Runtime
    const metadata = {
        projectName: projectName,
        language: locale,
        spriteCount: 0,
        blocksCount: 0,
        costumesCount: 0,
        listsCount: 0,
        scriptCount: 0,
        soundsCount: 0,
        variablesCount: 0
    };

    for (const target of vm.targets) {
        ++metadata.spriteCount;
        metadata.blocksCount += Object.keys(target.sprite.blocks._blocks).length;
        metadata.costumesCount += target.sprite.costumes_.length;
        metadata.scriptCount += target.sprite.blocks._scripts.length;
        metadata.soundsCount += target.sprite.sounds.length;
        for (const variableName in target.variables) {
            const variable = target.variables[variableName];
            if (variable.type === 'list') {
                ++metadata.listsCount;
            } else {
                ++metadata.variablesCount;
            }
        }
    }
    return metadata;
};

function getScriptsFromBlocks(blocks) {
    const scripts = [];
    for (const blockId in blocks) {
        const block = blocks[blockId];
        // トップレベルのブロック（他のブロックに接続されていないブロック）を探す
        if (!block.parent) {
            const script = [];
            let currentBlockId = blockId;
            // 連続するブロックをたどってスクリプトを再構築
            while (currentBlockId) {
                const currentBlock = blocks[currentBlockId];
                script.push(currentBlock); // ブロックをスクリプトに追加
                currentBlockId = currentBlock.next; // 次のブロックに移動
            }
            scripts.push(script); // 完成したスクリプトを追加
        }
    }
    return scripts;
}

function createMessagePackPacket(sendValue) {
    const json = {
      v: sendValue,
      c: 255,
    };
  
    const bytes = encode(json);
    return bytes;
}

// バイト配列を16進数の文字列に変換する関数
function bytesToHex(bytes) {
    return Array.from(bytes)
      .map(b => b.toString(16).padStart(2, "0"))
      .join("");
  }
  
module.exports = Scratch3NewBlocks;